import React from "react";
import { compose, mapProps } from "recompose";

import { connectToApi, ApiConnectedOptions } from "../connectToApi";

type InnerProps = React.Props<{}>;
type OuterProps = React.Props<{}>;

const Presenter = ({ children }: InnerProps) => <div>{children}</div>;

const createApiComponent = (options: ApiConnectedOptions) => compose<InnerProps, OuterProps>(
    connectToApi(options),
    mapProps(({ children }: OuterProps) => ({ children })),
)(Presenter);

export {
    createApiComponent,
    OuterProps as ApiComponentProps,
    Presenter as ApiComponentPresenter,
};
